import { z as o } from "zod";
const r = (e) => o.object({ id: e }).readonly();
export {
  r as createCreationResultSchema
};
//# sourceMappingURL=creation-result.js.map
